// SPDX-License-Identifier: MIT
// Web AI bridge — delegates to the existing Supabase edge-fn clients verbatim.
// Nothing here is new behaviour ; it just routes the seam to today's code so the
// deployed web app is byte-for-byte unchanged.
import { magnifyIdea } from '../auth/magnify';
import { converse } from '../auth/converse';
import { discoverAttachments } from '../projects/discover';
import type { AiBridge } from './types';

export const webAiBridge: AiBridge = {
  magnify: (idea, locale, ctx) => magnifyIdea(idea, locale, ctx),
  converse: (projectId, message, locale, conversationId, manifest, version) =>
    converse(projectId, message, locale, conversationId, manifest, version),
  discover: (projectId) => discoverAttachments(projectId),
};
